import { render, staticRenderFns } from "./promotion.vue?vue&type=template&id=665da33a&scoped=true"
import script from "./promotion.vue?vue&type=script&lang=js"
export * from "./promotion.vue?vue&type=script&lang=js"
import style0 from "./promotion.vue?vue&type=style&index=0&id=665da33a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665da33a",
  null
  
)

export default component.exports